<template>
  <div>
    <div class="grid grid-cols-12 gap-4">
      <div class="flex rounded-md shadow-sm col-span-12 sm:col-span-8 md:col-span-6 xl:col-span-10">
          <div class="relative flex items-stretch flex-grow focus-within:z-10">
              <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd" />
                  </svg>
              </div>
              <input type="text" v-model="searchedEmail" @keyup.enter="searchEmail" name="search_filter" id="search_filter" class="focus:ring-indigo-500 focus:border-indigo-500 block w-full rounded-none rounded-l-md pl-10 text-sm border-gray-300 placeholder-gray-400" placeholder="Search Email">
          </div>
          <button type="button" @click="searchEmail" id="search_button" class="-ml-px relative inline-flex items-center space-x-2 px-6 py-2 border border-indigo-600 text-sm font-medium rounded-r-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-white">
            Go
          </button>
      </div>

      <span class="relative z-0 flex shadow-sm rounded-md col-span-12 sm:col-span-4 md:col-span-3 xl:col-span-2">
          <a href='/admin/unsubscribers' class="-ml-px relative w-full inline-flex items-center justify-center px-3 py-2 rounded-md border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500">
              Clear
          </a>
      </span>
    </div>

    <!--div class="mb-7">
        <button @click="addUnsubscriberOption = 'add email'" class="w-full sm:w-auto sm:min-w-56 mr-0 sm:mr-4 mt-3 inline-flex items-center justify-center rounded-md border border-transparent shadow-sm p-2 bg-indigo-500 text-white hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 text-xs tracking-wide">
          Add unsubscriber
        </button>
        <button @click="addUnsubscriberOption = 'upload spreadsheet'" class="w-full sm:w-auto sm:min-w-56 mr-0 sm:mr-4 mt-3 inline-flex items-center justify-center rounded-md border border-transparent shadow-sm p-2 bg-indigo-500 text-white hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 text-xs tracking-wide">
          Upload unsubscriber emails
        </button>
    </div-->

    <div class="bg-white border border-gray-300 shadow-sm overflow-hidden rounded-md mt-6">
      <div class="border-b border-gray-300 flex items-center justify-between">
        <nav class="-mb-px inline-flex">
          <a href="javascript:void(0);" @click="addUnsubscriberOption = 'add email'" class="group inline-flex items-center py-2 sm:py-2.5 px-2 sm:px-5 border-b font-medium text-xs sm:text-sm" :class="addUnsubscriberOption == 'add email' ? 'border-indigo-500 text-indigo-600' :'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-400'">
            Add unsubscriber
          </a>

          <span class="border-r border-gray-300"></span>

          <a href="javascript:void(0);" @click="addUnsubscriberOption = 'upload spreadsheet'" class="group inline-flex items-center py-2 sm:py-2.5 px-2 sm:px-5 border-b font-medium text-xs sm:text-sm" :class="addUnsubscriberOption == 'upload spreadsheet' ? 'border-indigo-500 text-indigo-600' :'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-400'">
            Upload unsubscriber emails
          </a>
        </nav>
      </div>

      <!-- Add New Subscriber -->
      <div class="p-3 sm:p-4" v-if="addUnsubscriberOption == 'add email'">
        <div class="flex items-center">
          <div class="flex rounded-md shadow-sm flex-1">
            <div class="relative flex items-stretch flex-grow focus-within:z-10">
              <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <input type="text" name="email" v-model="email" placeholder="Enter Email" class="focus:ring-indigo-500 focus:border-indigo-500 block w-full rounded-none rounded-l-md pl-10 text-sm border-gray-300 h-10">
            </div>
            <button type="button" @click="addSubscriber" class="-ml-px relative inline-flex items-center px-4 sm:px-6 py-2 border border-indigo-600 text-sm font-semibold rounded-r-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-indigo-500 focus:border-indigo-50">
              Add
            </button>
          </div>

          <button type="button" @click="addUnsubscriberOption = ''" class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 ml-2 sm:ml-4">
            Close
          </button>
        </div>
        <span class="text-red-600 italic text-sm font-medium block mt-1.5" v-if="this.errors.email">{{errors.email}}</span>

        <!-- <div class="py-3 mt-4 border-t border-b border-gray-300">
          <div class="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 sm:gap-5 items-end">
            <input type="text" name="email" v-model="email" placeholder="Enter Email" class="flex-1 min-w-0 block w-full px-3 py-2 rounded-md focus:ring-indigo-500 focus:border-indigo-500 text-sm border-gray-300 placeholder-gray-400">
            <button @click="addSubscriber" class="w-full sm:w-auto sm:min-w-56 mr-0 sm:mr-4 mt-3 inline-flex items-center justify-center rounded-md border border-transparent shadow-sm p-2 bg-indigo-500 text-white hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 text-xs tracking-wide">
              Add
            </button>
            <button @click="addUnsubscriberOption = ''" class="w-full sm:w-auto sm:min-w-56 mr-0 sm:mr-4 mt-3 inline-flex items-center justify-center rounded-md border border-transparent shadow-sm p-2 bg-red-500 text-white hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 text-xs tracking-wide">
              Close
            </button>
          </div>
          <span class="text-red-600" v-if="this.errors.email">{{errors.email}}</span>
        </div> -->
      </div>

      <!-- Upload Spreadsheet -->
      <div class="p-3 sm:p-4" v-if="addUnsubscriberOption == 'upload spreadsheet'">
        <div class="flex items-center">
          <div class="flex rounded-md shadow-sm flex-1">
            <div class="relative flex items-stretch flex-grow focus-within:z-10">
              <input type="file" @change="fileUploaded" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" class="block w-full rounded-none rounded-l-md px-2 py-1.5 text-sm border border-gray-300 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500">
            </div>
            <button type="button" @click="uploadSubscribersEmails" class="-ml-px relative inline-flex items-center px-4 sm:px-6 py-2 border border-indigo-600 text-sm font-semibold rounded-r-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-indigo-500 focus:border-indigo-50">
              Upload
            </button>
          </div>

          <button type="button" @click="addUnsubscriberOption = ''" class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 ml-2 sm:ml-4">
            Close
          </button>
        </div>
        <span class="text-red-600 italic text-sm font-medium block mt-1.5" v-if="this.errors.unsubscriberFile">{{errors.unsubscriberFile}}</span>

        <!-- <div class="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 sm:gap-5 items-end">
            <input type="file" @change="fileUploaded" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" class="flex-1 min-w-0 block w-full px-3 py-2 rounded-md focus:ring-indigo-500 focus:border-indigo-500 text-sm border-gray-300 placeholder-gray-400">
            <button @click="uploadSubscribersEmails" class="w-full sm:w-auto sm:min-w-56 mr-0 sm:mr-4 mt-3 inline-flex items-center justify-center rounded-md border border-transparent shadow-sm p-2 bg-indigo-500 text-white hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 text-xs tracking-wide">
              Upload
            </button>
            <button @click="addUnsubscriberOption = ''" class="w-full sm:w-auto sm:min-w-56 mr-0 sm:mr-4 mt-3 inline-flex items-center justify-center rounded-md border border-transparent shadow-sm p-2 bg-red-500 text-white hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 text-xs tracking-wide">
              Close
            </button>
          </div>
          <span class="text-red-600" v-if="this.errors.unsubscriberFile">{{errors.unsubscriberFile}}</span> -->
      </div>

    </div>

    <div class="mt-4 flex flex-col">
        <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
              <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
                  <table class="min-w-full divide-y divide-gray-300">
                      <thead class="bg-gray-200">
                          <tr>
                              <th scope="col" class="whitespace-nowrap px-6 py-3 text-left text-sm font-medium text-gray-700">
                                  ##
                              </th>

                              <th scope="col" class="whitespace-nowrap px-6 py-3 text-left text-sm font-medium text-gray-700">
                                  Email
                              </th>

                              <th scope="col" class="whitespace-nowrap px-6 py-3 text-right text-sm font-medium text-gray-700">
                                Actions
                            </th>
                          </tr>
                      </thead>
                      <tbody class="divide-y divide-gray-200 bg-white">
                          <tr v-if="unsubscriberEmails.length == 0">
                            <td colspan="3" class="whitespace-nowrap px-6 py-4 text-sm font-medium text-gray-600 text-center">
                                No unsubscribers found
                            </td>
                          </tr>
                          <tr v-else-if="unsubscriberEmails.length > 0" v-for="(unsubscriber, index) in unsubscriberEmails">
                              <td class="whitespace-nowrap px-6 py-4 text-sm font-medium text-gray-900">
                                  {{ index + 1 }}
                              </td>

                              <td class="whitespace-nowrap px-6 py-4 text-sm font-medium text-gray-900">
                                  {{ unsubscriber.email }}
                              </td>

                              <td class="whitespace-nowrap px-6 py-4 text-right text-sm font-medium text-gray-900">
                                <a href="javascript:void(0)" @click="deleteUnsubscriber(unsubscriber)" class="text-red-600 underline">
                                  Delete
                                </a>
                            </td>
                          </tr>
                      </tbody>
                  </table>
              </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
  import UnsubscriberApi from "../services/api/Unsubscriber.js";
  export default {
    props: ["unsubscribers"],
    data() {
      return {
        errors: '',
        addUnsubscriberOption: '',
        email: "",
        unsubscriberEmails: [],
        unsubscriberListFile: null,
        searchedEmail:""
      };
    },
    created() {
      this.unsubscriberEmails = this.unsubscribers
    },
    methods: {
      addSubscriber() {

        this.errors = "";
        var errors = {};
        if(this.email == "") {
          errors.email= 'Please Enter Email'
          this.errors=errors
          return;
        }

        window.blockUI();

        UnsubscriberApi.add(this.email).then((response) => {

          if(response.data.errors) {
            errors.email = response.data.message.email[0]
            this.errors=errors
            return;
          }

          this.$toast.open('Unsubscriber email added successfully');

          var unsubscribers = response.data.unsubscribers;
          this.unsubscriberEmails = unsubscribers;
          this.email = ""

        }).finally(() => {
          window.unblockUI();
        });
      },
      uploadSubscribersEmails(event) {
        this.errors = "";
        var errors = {};

        let data = new FormData();
        data.append('unsubscriberListFile', this.unsubscriberListFile)

        if(this.unsubscriberListFile == null) {
          errors.unsubscriberFile= 'Please select a file to upload'
          this.errors=errors
          return
        }

        window.blockUI();

        UnsubscriberApi.uploadEmailList(data).then((response) => {

          if(response.data.errors) {
            errors.unsubscriberFile = "Something went wrong"
            console.log(response.data.message);
            this.errors=errors
            return;
          }

          this.$toast.open('Unsubscriber email(s) added successfully');

          var unsubscribers = response.data.unsubscribers;
          this.unsubscriberEmails = unsubscribers;

        }).finally(() => {
          window.unblockUI();
        });
      },
      fileUploaded(event) {
        this.unsubscriberListFile = event.target.files[0]
      },
      deleteUnsubscriber(unsubscriber) {
        if(confirm("Are you sure you want to delete " + unsubscriber.email + " from unsubscribers?") == true) {
          window.blockUI();

          UnsubscriberApi.delete(unsubscriber.id).then((response) => {
            this.$toast.open('Unsubscriber deleted successfully');
            var unsubscribers = response.data.unsubscribers;
            this.unsubscriberEmails = unsubscribers;
          }).finally(() => {
            window.unblockUI();
          });
        }
      },
      searchEmail() {
        UnsubscriberApi.getFilteredUnsubscribers(this.searchedEmail).then((response) => {
            var unsubscribers = response.data.unsubscribers;
            this.unsubscriberEmails = unsubscribers;
        })
      },

    }
  }
</script>
